import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=31c0f4e4&"
import script from "./BannerView.vue?vue&type=script&lang=js&"
export * from "./BannerView.vue?vue&type=script&lang=js&"
import style0 from "./BannerView.vue?vue&type=style&index=0&id=31c0f4e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports